// Schema das plantas do empreendimento Sofia.
//
// Cada planta tem 5 imagens compostas (1 base inteira colorida + 4 spotlights
// por área, mesma silhueta com a área X destacada em cor e o resto faded).
//
// Pipeline pra gerar essas imagens em SPEC_50_LP_SOFIA_CAMPOBELO.md:
// gpt-image-2 (clean + 4 spots) → birefnet (bg removal na base) →
// scripts/composite_plantas_spotlights.py (fill holes + brighten neutrals +
// position lock matemático).
//
// Coordenadas dos pins (x, y) em % relativo ao PNG normalizado.
// Detectadas matematicamente: mediana dos pixels saturados de cada spotlight.

export const PLANTAS = [
  {
    id: 'padrao-278',
    tab: 'Padrão',
    tabSuffix: null,
    nome: 'Tipo Final 2',
    metragem: '278 m²',
    tagline: '4 suítes · 3 vagas · 15 unidades',
    image: '/sofia/03-plantas-278-base-norm.png',
    imageAspect: 537 / 528,
    enabled: true,
    areas: [
      {
        id: 'suites',
        nome: '4 suítes',
        descricao: 'Quatro suítes em fileira voltadas pro jardim ao norte, com closets e banheiros privativos. Master com closet ampliado.',
        pin: { x: 46, y: 19 },
        spotlight: '/sofia/03-plantas-278-spot-suites-norm.png',
        fotos: ['/sofia/07-real-suite-328.jpg'],
      },
      {
        id: 'sala-intima',
        nome: 'Sala íntima',
        descricao: 'Estar íntimo com sofás em terracotta — espaço pra leitura, home office ou TV. Conecta as suítes ao social.',
        pin: { x: 10, y: 31 },
        spotlight: '/sofia/03-plantas-278-spot-sala-intima-norm.png',
        fotos: ['/sofia/07-real-sala-intima-278.jpg'],
      },
      {
        id: 'living',
        nome: 'Living + sala de jantar',
        descricao: 'Living social integrado com sala de jantar pra 8 lugares, lareira e mesa de centro. Pé-direito generoso e iluminação natural.',
        pin: { x: 22, y: 65 },
        spotlight: '/sofia/03-plantas-278-spot-living-norm.png',
        fotos: ['/sofia/07-real-living-270.jpg'],
      },
    ],
  },
  {
    id: 'premium-328',
    tab: 'Premium',
    tabSuffix: null,
    nome: 'Tipo Final 1',
    metragem: '328 m²',
    tagline: '4 suítes · 4 vagas · 28 unidades',
    image: '/sofia/03-plantas-328-base-norm.png',
    imageAspect: 785 / 735,
    enabled: true,
    areas: [
      {
        id: 'suites',
        nome: '4 suítes',
        descricao: 'Quatro suítes em fileira voltadas pro jardim ao norte. Master ampliada com closet maior e banheira.',
        pin: { x: 43, y: 22 },
        spotlight: '/sofia/03-plantas-328-spot-suites-norm.png',
        fotos: ['/sofia/05-gen-328-suites.jpg'],
      },
      {
        id: 'living',
        nome: 'Living social + terraço',
        descricao: 'Living social amplo com sala de jantar pra 8 lugares, integrado ao terraço externo com mesa de café e poltronas. Pé-direito generoso.',
        pin: { x: 66, y: 82 },
        spotlight: '/sofia/03-plantas-328-spot-living-norm.png',
        fotos: ['/sofia/07-real-living-garden-916.jpg'],
      },
    ],
  },
];
